import React from "react";
import deniedImage from "../../../../assets/Beneficiary Icons/Denied_Txn.png";
import createTransaction from "../../../../assets/create_transaction.png";
import dashboard from "../../../../assets/Dashboard.png";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./index.css";
import ErrorImage from "../../../../assets/Graphics/Error page graphic.svg";

const BeneCreateFailed = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const createAccountHandler = () => {
    navigate("/transaction/beneficiary_transaction/create");
  };

  const dashboardHandler = () => {
    navigate("/accounts/beneficiary/dashboard");
  };

  return (
    <div className="min-h-screen bg-[#754545] bene_createAccountFailureMainContainer">
      <div className="flex justify-center">
        <div className="flex flex-row max-w-screen-lg justify-center bene_createAccountFailureContainer">
          <div className="flex-1 mt-[66px] pt-[112px] bene_createAcc_FailureImg_container">
            <div className="flex min-w-screen mx-5 justify-center items-center bg-[#754545]">
              <div className="p-2 flex flex-col items-center justify-center text-center text-white text-2xl bene_createAccountFailureImageDiv">
                <img
                  src={ErrorImage}
                  width={"100%"}
                  height={"100%"}
                  alt=""
                  srcSet=""
                />
                <div className="pt-7 bene_createAccFailureText">
                  <p className="text-xl">Account creation failed</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 pt-32 pb-4 bene_createAccFailureDetails">
            <div
              className="flex flex-col mx-5 bg-white rounded-t-[32px] rounded-b-[38px] items-center justify-between bene_accFailureDetailsCard"
              style={{ height: "540px" }}
            >
              <div className="w-full flex flex-col gap-1 justify-left">
                <div className="flex flex-col font-bold pt-5 pb-3 px-7">
                  <p className="mx-1">Error</p>
                  <label className="text-[#707070] font-light text-sm mx-1">
                    Error message
                  </label>
                </div>
              </div>
              <div className="w-full divide-x-2 cursor-pointer text-white rounded-4xl bg-[#985555] flex justify-evenly items-center p-4 bene_createAccFailure_BottomDiv">
                <div
                  className="flex flex-col space-y-1 w-48 h-3/4 items-center justify-center text-center"
                  onClick={createAccountHandler}
                >
                  <div className="w-3/6 flex justify-center">
                    <img
                      width={"40%"}
                      height={"40%"}
                      src={createTransaction}
                      alt=""
                      srcSet=""
                    />
                  </div>
                  <p className="text-xs">
                    Create
                    <br />
                    transaction
                  </p>
                </div>

                <div
                  onClick={dashboardHandler}
                  className="flex flex-col space-y-1 w-48 h-3/4 items-center justify-center text-center"
                >
                  <div className="w-3/6 flex justify-center">
                    <img
                      width={"40%"}
                      height={"40%"}
                      src={dashboard}
                      alt=""
                      srcSet=""
                    />
                  </div>
                  <p className="text-xs">
                    Go to <br /> dashboard
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeneCreateFailed;
